// extracted by mini-css-extract-plugin
export default {"card":"UsersListMobile_card__dLieL","gridContainer":"UsersListMobile_gridContainer__ES7K1","title":"UsersListMobile_title__i81I4"};